module.exports = __webpack_public_path__ + "img/43_59.99c20c60.png";